package top.wcpe.allincore.ui.runtime.render.model

/**
 * UI 渲染层枚举：6 个固定层号，层间顺序硬编码（层号小的先绘制）。
 *
 * 层缓冲模式下，每帧所有绘制命令按层分组，endFrame() 时按 0→5 顺序逐层提交。
 *
 * ADR-0072 决策 1 镜像：真源为 `platform-client-api` 的
 * `top.wcpe.allincore.platform.client.api.render.RenderLayer`
 * （纯 Java 8 对外 API，按 ADR-0002 不得 KMP 化）。值名、声明序与 [id] 字段照抄真源
 * （id/COUNT 为跨层接缝约定，冻结保序），一致性由 jvmTest 的 RenderModelConsistencyTest
 * 逐值断言 name + ordinal + id + COUNT 守护。
 */
// 层号字面量即语义（照抄真源接缝序，由一致性测试冻结），强折命名常量只增噪音，故豁免 MagicNumber。
@Suppress("MagicNumber")
enum class RenderLayer(
    /** 层号，用作层数组索引 */
    val id: Int,
) {
    /** 纯色/纹理/圆角背景、阴影、边框 */
    BACKGROUND(0),

    /** 文本、图片、进度条、分割线、开关/复选框 */
    CONTENT(1),

    /** 物品图标（Slot 的 drawItem 部分） */
    ITEM(2),

    /** 实体模型预览 */
    ENTITY(3),

    /** hover/pressed/focus/disabled 状态叠加、选中轮廓、反馈动画、涟漪特效 */
    OVERLAY(4),

    /** Dropdown 弹出、Tooltip、Modal、Toast */
    FLOATING(5),
    ;

    companion object {
        /** 固定层数，用于分配层数组容量 */
        const val COUNT: Int = 6
    }
}
